import { Link } from "react-router-dom";

const ORG = "Orlando for Senate";
const EMAIL = "info@orlandojrivera.com";

const Legal = ({ to, label, testid }) => (
  <Link to={to} target="_blank" className="text-campaignRed underline" data-testid={testid}>{label}</Link>
);

const Mail = ({ testid }) => (
  <a href={`mailto:${EMAIL}`} className="text-campaignRed underline" data-testid={testid}>{EMAIL}</a>
);

export const SmsConsent = ({ checked, onChange, idPrefix }) => {
  const terms = (n) => <Legal to="/terms" label="Terms & Conditions" testid={`${idPrefix}-sms-terms-link${n}`} />;
  const privacy = (n) => <Legal to="/privacy" label="Privacy Policy" testid={`${idPrefix}-sms-privacy-link${n}`} />;
  return (
    <div className="space-y-3 border border-gray-200 bg-white/60 p-4 text-xs text-gray-600 leading-relaxed" data-testid={`${idPrefix}-sms-consent`}>
      <p data-testid={`${idPrefix}-sms-disclosure`}>
        By entering your phone number and selecting to opt in, you consent to join a recurring SMS/MMS text messaging
        program that will provide alerts, donation requests, updates, and other important information. By participating,
        you agree to the {terms("")} and {privacy("")} for autodialed messages from {ORG} to the number you provide.
        Message frequency varies. Msg &amp; data rates may apply. Reply HELP for help or STOP to opt out at any time.
        Email us at <Mail testid={`${idPrefix}-sms-email-link`} /> for assistance. SMS opt-in information and consent
        are not sold, rented, or shared with third parties for their own marketing purposes.
      </p>
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-5 w-5 flex-shrink-0 accent-campaignRed cursor-pointer"
          data-testid={`${idPrefix}-sms-checkbox`}
        />
        <span className="text-sm font-semibold text-campaignBlack" data-testid={`${idPrefix}-sms-checkbox-label`}>
          I agree to receive recurring SMS/MMS text messages from {ORG}. <span className="font-normal text-gray-500">(Optional)</span>
        </span>
      </label>
      <div className="space-y-2" data-testid={`${idPrefix}-sms-details`}>
        <p>
          By entering your mobile phone number, checking this optional box, and submitting this form, you consent to join
          a recurring SMS/MMS text messaging program from {ORG}. Messages may be sent using an autodialer to the number you provide.
        </p>
        <p><strong>Privacy Policy instructions:</strong> To learn how we collect, use, and protect your information, click the {privacy("-2")} link in this form. The Privacy Policy is also available under the Legal section in the website footer.</p>
        <p><strong>How to opt out:</strong> Reply STOP at any time to opt out and stop receiving messages.</p>
        <p><strong>How to receive help:</strong> Reply HELP for help or email <Mail testid={`${idPrefix}-sms-help-email-link`} /> for assistance.</p>
        <p><strong>Message and data rates:</strong> Msg &amp; data rates may apply.</p>
        <p><strong>Message frequency:</strong> Message frequency varies.</p>
        <p><strong>Types of messages:</strong> Messages may include campaign alerts, donation and fundraising requests, campaign updates, voter outreach, candidate information, volunteer opportunities, event invitations and reminders, polling questions, surveys, get-out-the-vote reminders, election information, public service announcements, and other important campaign information.</p>
        <p>By participating, you agree to the {terms("-2")} and {privacy("-3")}. Consent is not a condition of making a donation, volunteering, supporting the campaign, purchasing anything, or using this website.</p>
        <p>SMS opt-in information and consent are not sold, rented, or shared with third parties for their own marketing purposes.</p>
        <p className="font-semibold">Paid for by Orlando for Senate.</p>
      </div>
    </div>
  );
};
